module.exports = __webpack_public_path__ + "static/media/iconmonstr-briefcase-3.873e2a37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/iconmonstr-briefcase-3.svg
// module id = 718
// module chunks = 0